<template>
  <div class="component-table-list-wrapper" :class="className">
    <div class="ub fw ub-ac ub-pc zhezhao" v-if="loading">
      <a-spin :spinning="loading" class="ub spin-loading"></a-spin>
    </div>

    <div class="table-header ub ub-ps ub-ac fw" v-if="hasHeaderSlot">
      <slot name="header"></slot>
    </div>

    <div class="ub spaceBetween" v-if="hasButtonsSlot && showButtons">
      <a-space :size="10" style="margin-bottom: 10px" class="table-buttons-a-space">
        <slot name="buttons"> </slot>
      </a-space>
      <editableCell
        v-if="showEditCell"
        :columns="computedColumns"
        :xTable="xTable1"
        @changeColumns="changeColumns"
        :tabeleBizCode="tabeleBizCode"
      ></editableCell>
      <SettingOutlined @click="setCol" v-if="showCustomSetting" :style="{ fontSize: '16px' }" />
    </div>
    <data class="ub spaceBetween"  v-if="hasButtonsBottomSlot">
      <slot name="buttonsBottom"> </slot>
    </data>
    <vxe-table
      class="responsive-table a-table"
      id="myCustomUpdate"
      :border="border"
      :show-header="showHeader"
      ref="xTable1"
      :height="newTableHeight"
      :max-height="maxHeight"
      :row-config="{ isCurrent: true, isHover: true, ...rowConfig }"
      :tooltip-config="{ enterable: true, contentMethod: tooltipContentMethod }"
      :column-config="{ resizable: true, maxFixedSize: 10 }"
      :data="dataSource"
      :seq-config="tableSeq"
      :footer-method="tableConfig.footerMethod"
      :show-footer="tableConfig.footerMethod ? true : false"
      :row-class-name="tableConfig?.setRowClassName"
      :cell-class-name="tableConfig?.setCellClassName"
      :checkbox-config="newCheckboxConfig"
      @custom="customEvent"
      :customConfig="customConfig"
      :radio-config="radioConfig"
      :edit-config="editConfig"
      :resizable-config="{minWidth:0}"
      @checkbox-all="selectChangeEvent"
      @checkbox-change="selectChangeEvent"
      @radio-change="radioChangeEvent"
      @cell-click="cellClickEvent"
      @resizable-change="resizableChange"
      :sort-config="{ remote: true, trigger: 'cell', orders: ['desc', 'asc', null] }"
      @sort-change="sortChangeEvent"
    >
      <vxe-column
        type="checkbox"
        width="50"
        :fixed="maxHeight ? '' : 'left'"
        align="center"
        :show-overflow="false"
        v-if="showCheckbox && !showRadiobox"
      ></vxe-column>

      <vxe-column
        type="radio"
        width="50"
        fixed="left"
        align="center"
        :show-overflow="false"
        v-if="showRadiobox"
      ></vxe-column>

      <vxe-column type="expand" width="50" v-if="expandSlot != ''">
        <template #content="{ row, rowIndex, column, columnIndex }">
          <slot :name="expandSlot" :column="column" :record="row" :columnIndex="columnIndex">
            123</slot
          >
        </template>
      </vxe-column>
      <vxe-column
        :fixed="maxHeight ? '' : 'left'"
        type="seq"
        field="seq"
        width="80"
        align="center"
        title="序号"
        v-if="showSeq"
      ></vxe-column>
      <template
        v-for="{
          slots,
          type,
          key,
          title,
          dataIndex,
          fixed,
          width,
          align = 'left',
          titlePrefix = null,
          children = [],
          isShow = true,
          sort = false,
          visible = true,
        } in computedColumns"
      >
        <template v-if="children.length == 0">
          <vxe-column
            :titlePrefix="titlePrefix"
            v-if="isShow"
            show-overflow="tooltip"
            :field="key || dataIndex"
            :title="title"
            :fixed="fixed"
            :type="type"
            :width="setMinWidth?null:(flexFlag ? width : '')"
            :align="align"
            :min-width="setMinWidth?width:null"
            :key="key"
            :sortable="sort"
            :visible="visible"
          >
            <template
              #header="{ column, columnIndex, $columnIndex, _columnIndex, $rowIndex }"
              v-if="
                slots &&
                slots?.title &&
                (key !== 'lastModifiedTime' || dataIndex !== 'lastModifiedTime')
              "
            >
              <slot :name="slots.title" :column="column" :columnIndex="columnIndex">
                {{ title || "" }}
              </slot>
            </template>
            <template
              #header="{ column, columnIndex, $columnIndex, _columnIndex, $rowIndex }"
              v-if="(key == 'lastModifiedTime' || dataIndex == 'lastModifiedTime') && timeSort"
            >
              <span @click="reset">最近更新时间</span>
              <sort-icon :isRest="isRest" @orderSort="lastTimeSort"></sort-icon>
              <img
                src="../../assets/images/timeSort.png"
                style="width: 14px; height: 14px; margin-left: calc(100% - 120px); cursor: pointer"
              />
              <a-range-picker
                v-model:value="lastTime"
                class="append-to-table"
                :ranges="ranges"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                style="position: absolute; left: 150px; top: 0px; opacity: 0; cursor: pointer"
                @change="timeChange"
              >
                <template #renderExtraFooter>
                  <div style="text-align: right">
                    <a-button size="small" @click="clearTime" :disabled="lastTime.length == 0"
                      >清除</a-button
                    >
                  </div>
                </template>
              </a-range-picker>
            </template>
            <template #default="{ row, rowIndex }">
              <slot :name="key || dataIndex" :record="row" :index="rowIndex">
                <!-- {{ row[key] ? row[key] : row[dataIndex] ? row[dataIndex] : "-" }} -->
                {{
                  row[key] ? row[key] : row[dataIndex] ? row[dataIndex] : row[key] === 0 ? 0 : "-"
                }}
              </slot>
            </template>

            <template #footer="{ items, _columnIndex }" v-if="slots && slots?.footer">
              <slot :name="slots.footer" :items="items" :_columnIndex="_columnIndex"> </slot>
            </template>
          </vxe-column>
        </template>

        <template v-else>
          <vxe-colgroup :title="title" :align="align" v-if="isShow">
            <template
              #header="{ column, columnIndex, $columnIndex, _columnIndex, $rowIndex }"
              v-if="slots && slots?.title"
            >
              <slot :name="slots.title" :column="column" :columnIndex="columnIndex">
                {{ title || "" }}
              </slot>
            </template>

            <template v-for="(item, index) in children">
              <vxe-column
                v-if="item['isShow'] != null ? item['isShow'] : true"
                show-overflow="tooltip"
                :field="item.key || item.dataIndex"
                :title="item.title"
                :fixed="item.fixed"
                :type="item.type"
                :width="item.width < 80 ? 80 : item.width"
                :align="item.align"
                :key="item.key"
              >
                <template #header="{ row, rowIndex }" v-if="item.slots && item.slots?.title">
                  <slot :name="item.slots.title" :record="row" :index="rowIndex">
                    <!-- {{
                      row[item.key]
                        ? row[item.key]
                        : row[item.dataIndex]
                        ? row[item.dataIndex]
                        : "-"
                    }} -->
                  </slot>
                </template>

                <template #default="{ row, rowIndex }">
                  <slot :name="item.key || item.dataIndex" :record="row" :index="rowIndex">
                    {{
                      row[item["key"]]
                        ? row[item["key"]]
                        : row[item.dataIndex]
                        ? row[item.dataIndex]
                        : row[item["key"]] === 0
                        ? 0
                        : "-"
                    }}
                  </slot>
                </template>

                <template #footer="{ items, _columnIndex }" v-if="item.slots && item.slots?.footer">
                  <slot :name="item.slots.footer" :items="items" :_columnIndex="_columnIndex">
                  </slot>
                </template>
              </vxe-column>
            </template>
          </vxe-colgroup>
        </template>
      </template>

      <template #empty>
        <slot :name="'emptyTemplate'">
          <a-empty :image="simpleImage">
            <template #description>暂无数据</template>
          </a-empty>
        </slot>
      </template>
    </vxe-table>

    <template v-if="(dataSource && dataSource.length > 0)">
      <div class="pager-container">
        <div class="pager-inline-footer table-footer ub ub-ps ub-ac fw" v-if="hasFooterSlot">          <slot name="footer"></slot>
        </div>
        <vxe-pager
          v-show="pagination.pageSize > 0"
          perfect
          :layouts="[
            'Total',
            'PrevPage',
            'Number',
            'NextPage',
            'Sizes',
            showFullJump ? 'FullJump' : '',
          ]"
          v-model:current-page="pagination.current"
          v-model:page-size="pagination.pageSize"
          :total="pagination.total"
          :pageSizes="[10, 15, 20, 50, 100,200,500]"
          @page-change="onTableChange"
          style="height: 48px !important"
        ></vxe-pager>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  PropType,
  ref,
  watch,
  computed,
  nextTick,
  reactive,
} from "vue";
import { VXETable, VxeTableInstance, VxeTableEvents, VxeTablePropTypes } from "vxe-table";
import { Empty } from "ant-design-vue";
import sortIcon from "./sortIcon";
import moment from "moment";
import editableCell from "./editableCell.vue";
import { useStore } from "@/store";
import { update } from "lodash";
import { SettingOutlined } from "@ant-design/icons-vue";
import { TableListService } from "./table-list.service";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import _ from "lodash";
export default defineComponent({
  isGlobal: true,
  name: "TableWrapper",
  components: { sortIcon, editableCell, SettingOutlined },
  props: {
    showPagination: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showRadiobox: {
      type: Boolean,
      default: false,
    },
    showCustomSetting: {
      type: Boolean,
      default: false,
    },
    expandSlot: {
      type: String,
      default: "",
    },
    showEditCell: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    tableHeight: {
      type: Number,
      default: 200,
    },
    maxHeight: {
      type: Number,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showFullJump: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dataConfig: {
      type: Object,
    },
    rowKey: {
      type: String,
      default: "id",
    },
    className: {
      type: String,
      default: "",
    },
    tableConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rowConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    class: {
      type: String,
      default: "responsive-table",
    },
    timeSort: {
      type: Boolean,
      default: false,
    },
    showSeq: {
      type: Boolean,
      default: true,
    },
    tabeleBizCode: {
      // 动态列在后台存表的唯一值，为空时不保存
      type: String,
      default: "",
    },
    bizType: {
      // 动态列在后台存表的唯一值，为空时不保存
      type: String,
      default: undefined,
    },
    editConfig: {
      type: Object,
      default: () => {},
    },
    checkboxConfig: {
      type: Object as PropType<VxeTablePropTypes.CheckboxConfig>,
      default: () => {
        return {};
      },
    },
    radioConfig: {
      type: Object,
      default: () => {
        return { highlight: true };
      },
    },
    showTooTip: {
      type: Boolean,
      default: true,
    },
    flowStatus: {
      type: String,
      default: undefined,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    border: {
      type: String,
      default: "full",
    },
    setMinWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasFooterSlot() {
      return this.$slots.footer && this.$slots.footer().findIndex((o) => o.type !== Comment) !== -1;
    },
    hasHeaderSlot() {
      return this.$slots.header && this.$slots.header().findIndex((o) => o.type !== Comment) !== -1;
    },
    hasButtonsSlot() {
      return (
        this.$slots.buttons && this.$slots.buttons().findIndex((o) => o.type !== Comment) !== -1
      );
    },
    hasButtonsBottomSlot() {
      return (
        this.$slots.buttonsBottom && this.$slots.buttonsBottom().findIndex((o) => o.type !== Comment) !== -1
      );
    },
  },
  emits: [
    "onTableChange",
    "onSelectionChange",
    "onRadioChange",
    "cellClickEvent",
    "lastTimeEvent",
    "changeColumns",
    "onSortChange",
    "updateColumn",
  ],
  setup(props, { emit }) {
    const store = useStore();
    const onTableChange = (e) => {
      e.current = e.currentPage;
      emit("onTableChange", e);
    };
    const newTableHeight = computed(() => {
      return !props.showPagination ? props.tableHeight + 48 : props.tableHeight;
    });
    const newCheckboxConfig = computed(() => {
      return { ...props.checkboxConfig, ...{ checkField: "checkedTableRow" } };
    });
    const lastTime = ref([]);
    const flexFlag = ref(false);
    let lastOrder = ref("");
    const ranges = {
      今天: [moment(), moment()],
      昨天: [moment().subtract(1, "days").endOf("day"), moment()],
      一周前: [moment().subtract(7, "days").endOf("day"), moment()],
    };
    const xTable1 = ref({} as VxeTableInstance);
    const tableSeq = ref({
      seqMethod({ rowIndex }) {
        // // console.log("🚀 ~ file: index.vue:409 ~ seqMethod ~ rowIndex:", rowIndex)
        if (props.pagination.current) {
          return `${rowIndex + (props.pagination.current - 1) * props.pagination.pageSize + 1}`;
        }
        return rowIndex + 1;
      },
    });
    const selectAllChangeEvent: VxeTableEvents.CheckboxAll = ({ checked }) => {
      const $table = xTable1.value;
      const records = $table.getCheckboxRecords();
      emit(
        "onSelectionChange",
        records.reduce((o, cur) => {
          o.push(cur.id);
          return o;
        }, [])
      );
    };
    const selectChangeEvent: VxeTableEvents.CheckboxChange = ({ checked }) => {
      const $table = xTable1.value;
      const records = $table.getCheckboxRecords();
      let emitData = records.reduce((o, cur) => {
        o.push(cur[props.rowKey]);
        return o;
      }, []);
      if (props.dataConfig?.format) {
        emitData = props.dataConfig?.format(records);
      } else if (props.dataConfig?.pick?.length > 0) {
        emitData = records.reduce((pre, cur) => {
          let tmp = {};
          props.dataConfig?.pick.forEach((u) => {
            tmp[u] = cur[u];
          });
          pre.push(tmp);
          return pre;
        }, []);
      }
      emit("onSelectionChange", emitData);
    };
    const changeColumns = (data) => {
      emit("changeColumns", data);
    };
    const sortChangeEvent = (params) => {
      emit("onSortChange", params);
      resetCheckboxRadiobox();
    };
    const resetCheckboxRadiobox = () => {
      emit("onSelectionChange", []);
      emit("onRadioChange", {});
    };
    // 表格点击事件
    const cellClickEvent = async ({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      triggerRadio,
      triggerCheckbox,
      triggerTreeNode,
      triggerExpandNode,
      $event,
    }) => {
      emit("cellClickEvent", { row, rowIndex, columnIndex });
      // // console.log(row, rowIndex, columnIndex);
    };
    const radioChangeEvent: VxeTableEvents.RadioChange = ({ row }) => {
      emit("onRadioChange", {
        item: [row],
        selectedRowKeys: [row.id],
      });
    };
    const isRest = ref(false);

    const clearSort = () => {
      isRest.value = true;
      lastTime.value = [];
      const $table = xTable1.value;
      if ($table) {
        $table.clearSort();
      }
      // emit("lastTimeEvent", { order: '', lastTime: lastTime.value });
    };
    const lastTimeSort = (order) => {
      lastOrder.value = order;
      isRest.value = false;
      emit("lastTimeEvent", { order, lastTime: lastTime.value });
      resetCheckboxRadiobox();
    };
    // 清除筛选时间
    const clearTime = () => {
      lastTime.value = [];
      emit("lastTimeEvent", { order: lastOrder.value, lastTime: lastTime.value });
      resetCheckboxRadiobox();
    };
    const timeChange = (day) => {
      // // console.log("days-----", day);
      emit("lastTimeEvent", { order: lastOrder.value, lastTime: lastTime.value });
      resetCheckboxRadiobox();
    };
    const tooltipContentMethod = ({ type, column, row, items, _columnIndex }) => {
      // // console.log("~~~~~~~~~~~~~~",type, column, row, items, _columnIndex );

      const { property } = column;
      if (props.showTooTip) {
        if (Array.isArray(row[property])) {
          return row[property].join(",");
        }
      }
      return null;
    };
    //重新加载数据
    const reloadData = () => {
      const $table = xTable1.value;
      if ($table) {
        $table.reloadData(props.dataSource);
      }
    };
    //加载数据
    const loadData = () => {
      const $table = xTable1.value;
      if ($table) {
        $table.loadData(props.dataSource);
      }
    };
    const setCol = () => {
      const $table = xTable1.value;
      if ($table) {
        $table.openCustom();
      }
    };
    watch(
      () => props.tableHeight,
      (n, o) => {
        nextTick(() => {
          loadData();
        });
      },
      { immediate: true }
    );
    const settingCol = ref();
    const settingColCustomData= ref();
    // 根据权限限制列的显示与隐藏
    const disabledCol:any=['seq'];
    let computedColumns = computed(() => {
      let c: any = [];
      if(!settingCol.value||settingCol.value.length==0){
        settingCol.value=props.columns;
      }

      let allWidth = 0;
      let visibleCols=settingColCustomData.value?.visibleData||{};
      for (let i = 0; i < settingCol.value?.length; i++) {
        if(visibleCols[settingCol.value[i]["key"]]==true){
          settingCol.value[i]["visible"] = false;
        }
        //@ts-ignore
        if (
          (settingCol.value[i]["premKey"] &&
          !store.state.user.buttons[settingCol.value[i]["premKey"]])
        ) {
          //则不添加
        } else {
          c.push(settingCol.value[i]);
        }
        if (!settingCol.value[i]["fixed"]) {
          settingCol.value[i]["fixed"] = "";
        }

        if (settingCol.value[i]["width"]) {
          allWidth = allWidth + settingCol.value[i]["width"]
        }else {
          if (settingCol.value[i]["children"]) {
            let allCount = 0;
            settingCol.value[i]["children"].map((e: any) => {
              if (e.width) {
                allCount = allCount + (e.width || 50);
              }
            });
            allWidth = allWidth + allCount;
            allCount = 0;
          }else {
            allWidth = allWidth + 50;
          }
        }
        if (settingCol.value[i]["disabled"] ) {
          disabledCol.push(settingCol.value[i].dataIndex||settingCol.value[i].key);
        }
      }

      // console.log('allWidth', allWidth);
      allWidth = props.expandSlot != '' ? allWidth + 180 : allWidth + 130;
      //disabledCol 去重
      disabledCol.filter((item, index, arr) => {
        return arr.indexOf(item) === index;
      })

      nextTick(() => {
        const $table = xTable1.value;
        let tableWidh=  $table.$el?.offsetWidth
        // console.log('allWidth', allWidth);
        // console.log('2222222', tableWidh);
        flexFlag.value =  allWidth > tableWidh ? true : false;
        // console.log('flexFlag.value', flexFlag.value);
        allWidth = 0;
        emit("updateColumn", {col:computedColumns.value,visibleData:visibleCols});
        if ($table) {
          // console.log("🚀 ~ setup ~ computedColumns.value:", computedColumns.value)
          $table.refreshColumn();
        }
      });

      return c;
    });

    const updateColumns = () => {
      // // console.log(
      //   "🚀 ~ file: index.vue:557 ~ computedColumns ~ computedColumns:",
      //   computedColumns,
      //   xTable1.value
      // );
      const $table = xTable1.value;
      if ($table) {
        $table.refreshColumn();
      }
    };
    const showButtons = ref(true);
    const { loading, run, data } = TableListService.useGetColumnsSettingApi();
    const { run: runSet } = TableListService.useSetColumnsSettingApi();

    const currId = ref();

    watch(
      () => props.flowStatus,
      (n, o) => {
        // console.log("🚀 ~ file: index.vue:644 ~ setup ~ n:", n);
        if (n && props.showCustomSetting) {
          for (let i = 0; i < computedColumns.value.length; i++) {
            if (
              computedColumns.value[i]["showFlowStatus"] &&
              !computedColumns.value[i]["showFlowStatus"].includes(n)
            ) {
              computedColumns.value[i]["isShow"] = false;
            } else {
              computedColumns.value[i]["isShow"] = true;
            }
          }
        }
      },
      { immediate: true }
    );
    // 查询接口
    const findCustomSetting = async () => {
      if (!props.showCustomSetting) {
        settingCol.value = props.columns;
        return {};
      }
      if (props.bizType) {
        await run(props.bizType);
        // console.log("🚀 ~ file: index.vue:628 ~ findCustomSetting ~ data:", data);
        if (data && data.value) {
          currId.value = data.value?.id;
          try {
            let content = JSON.parse(data.value?.content);
            settingCol.value = content.content;

            // settingCol.value = props.columns;
            if (props.flowStatus) {
              for (let i = 0; i < settingCol.value.length; i++) {
                if (
                  settingCol.value[i]["showFlowStatus"] &&
                  !settingCol.value[i]["showFlowStatus"].includes(props.flowStatus)
                ) {
                  settingCol.value[i]["isShow"] = false;
                } else {
                  settingCol.value[i]["isShow"] = true;
                }
              }
            }
            settingCol.value = settingCol.value.sort((a, b) => a.sortIndex - b.sortIndex);
            settingColCustomData.value = content?.customData;
            return content?.customData;
          } catch (e) {
            settingCol.value = props.columns;
            return {};
          }
        } else {
          settingCol.value = props.columns;
          return {};
        }
      } else {
        settingCol.value = props.columns;
        return {};
      }
    };

    // 保存接口
    const saveCustomSetting = async (isReset?,colp?,colData?) => {
      if (!props.showCustomSetting) {
        return true;
      }
      let data: any = xTable1.value?.getCustomStoreData();
      if(colp){
        data=colp;
      }
      // console.log("🚀 ~ file: index.vue:655 ~ saveCustomSetting ~ data:", data);
      emit("updateColumn", {col:computedColumns.value,visibleData:data.visibleData});
      let content: any = _.cloneDeep(computedColumns.value);
      if (isReset) {
        content = _.cloneDeep(colData);
      }
      if (data) {
        content.map((item) => {
          let d_item: any = props.columns.find((c: any) => c.key == item["key"]);
          if (!colData) {
            item["sortIndex"] = data["sortData"][item["key"]];
          }
          if (data["resizableData"] && data["resizableData"][item["key"]]) {
            item["width"] = data["resizableData"][item["key"]];
          } else {
            item["width"] = d_item["width"];
          }
          if (data["fixedData"] && data["fixedData"][item["key"]]) {
            item["fixed"] = data["fixedData"][item["key"]];
          } else {
            item["fixed"] = d_item["fixed"];
          }
          if (data["visibleData"]&&data["visibleData"][item["key"]]) {
            // item["isShow"] = data["visibleData"][item["key"]];
            item["visible"] = data["visibleData"][item["key"]];
            // delete item["visible"]
          } else {
            item["visible"] = d_item["visible"];
          }
        });
      }
      content = content.sort((a, b) => a.sortIndex - b.sortIndex);
      let colStr = JSON.stringify({ content, customData: data });
      await runSet({
        id: currId.value,
        bizType: props.bizType,
        content: colStr,
      });
    };

    const customConfig = reactive<any>({
      storage: true,
      allowFixed: true,
      restoreStore({ ...res }) {
        // console.log("🚀 ~ file: index.vue:655 ~ restoreStore ~ res:", res, findCustomSetting());
        return findCustomSetting();
      },
      visibleMethod() {
        return true;
      },
      checkMethod ({ column }) {
          return !disabledCol.includes(column.field)
      },
      updateStore({ type,storeData }) {
        // // console.log("🚀 ~ file: index.vue:698 ~ updateStore ~ res:", res);
        if (type == "confirm") {
          saveCustomSetting(false,storeData);
        } else if (type == "reset") {
          saveCustomSetting(true,storeData,props.columns);
          settingCol.value = props.columns;

          // xTable1.value.resetColumn();
        }
        // 模拟异步，实现服务端保存
        // return saveCustomSetting();
      },
    });
    onMountedOrActivated(async () => {
      let tmp = document.getElementsByClassName("table-buttons-a-space")[0];
      if (tmp) {
        let t = tmp.getElementsByClassName("ant-space-item");
        // // console.log("t", t);
        showButtons.value = !Array.from(t).every((o: any) => {
          return o.children?.length == 0;
        });
      }
      await findCustomSetting();
    });
    const customEvent = async ({ type }) => {
      // console.log(`点击 ${type}`);
      // if (type == "confirm") {
      //   await saveCustomSetting();
      // } else if (type == "reset") {
      //   settingCol.value = props.columns;
      //   xTable1.value.resetColumn();
      // }
    };
    const resizableChange = async ({ $rowIndex, column, columnIndex, $columnIndex, $event }) => {
      if (props.showCustomSetting) {
        await saveCustomSetting();
      }

      // // console.log(
      //   "🚀 ~ file: index.vue:744 ~ resizableChange ~ $rowIndex, column, columnIndex, $columnIndex, $event:",
      //   $rowIndex,
      //   column,
      //   columnIndex,
      //   $columnIndex,
      //   $event
      // );
    };
    return {
      onTableChange,
      tableSeq,
      selectAllChangeEvent,
      selectChangeEvent,
      radioChangeEvent,
      newCheckboxConfig,
      xTable1,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      showButtons,
      tooltipContentMethod,
      reloadData,
      cellClickEvent,
      lastTime,
      ranges,
      lastTimeSort,
      clearTime,
      timeChange,
      isRest,
      flexFlag,
      clearSort,
      changeColumns,
      newTableHeight,
      computedColumns,
      updateColumns,
      sortChangeEvent,
      setCol,
      customEvent,
      customConfig,
      resizableChange,
    };
  },
});
</script>

<style scoped lang="scss">
.zhezhao {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 100;
}
.spaceBetween {
  justify-content: space-between;
}

.component-table-list-wrapper {
  position: relative;
}

.pager-container {
  position: relative;
}
// .pager-inline-footer {
//   position: absolute;
//   left: 120px;
//   top: 0;
//   bottom: 0;
//   display: flex;
//   align-items: center;
//   z-index: 1;
//   font-size: 14px;
//   color: rgba(0, 0, 0, 0.85);
// }
:deep(.ant-scrolling-effect) {
  overflow: visible !important;
}
:deep(.vxe-table--body) {
  border-collapse: collapse;
}
.table-footer {
  padding: 16px;
  box-sizing: border-box;
  background-color: rgb(250, 250, 250);
  border: 1px solid #e8eaec;
  border-top: none;
}

</style>
